import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import { AuthActions } from '../actions';

export const useBoundAuthActions = (): typeof AuthActions => {
    const dispatch = useDispatch();
    const authActions = useMemo(() => bindActionCreators(AuthActions, dispatch), [dispatch]);

    return authActions;
};
